export default __webpack_public_path__ + "static/media/appStore.a42e378b.svg";